import { Skeleton, Box } from "@mui/material";

export const createSkeletonColumns = (columns) =>
  columns.map((col) => ({
    ...col,
    renderCell: () => (
      <Box
        sx={{
          height: "100%",     
          width: "100%",
          display: "flex",
          alignItems: "center", 
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height={12}
          sx={{ borderRadius: 1 }}
        />
      </Box>
    ),
  }));

export const skeletonRows = Array.from({ length: 10 }, (_, i) => ({ id: i }));
